var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{attrs:{"card":"","header":_vm.$t('overview'),"loading":_vm.loading,"error":_vm.error,"type":"bar","height":"380","options":_vm.echartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }